import { makeAutoObservable } from 'mobx';   
import { Comment, OperationLog } from '@/common/model';
import { demandApi } from './DemandApi';


export interface Demand{
    id:string | number | null
    content:string
    submitterId:string | number
    submitterName:string
    executorId:string | number
    executorName:string
    submitTime:Date
    status:number
    comments:Comment[] | null
    logs:OperationLog[] | null
}

export class DemandAddEditParam{
    id:string | number | null
    content:string 
    submitterId:string | number
    executorId:string | number
    status:number
}


export interface FilterOptions{
    submitterId: number
    status:number[]//允许的状态，当为null时，指所有状态
}

export interface SortOptions{
    bySubmitTime:boolean;
    bySubmitter:boolean;
    byExecutor:boolean;
    byStatus:boolean;
    order:'asc' | 'desc';
}

export class DemandPageModel{
    filterOptions:FilterOptions; 
    demandList : Demand[];
    sortOptions: SortOptions;
    filteredList: Demand[];
    isLoaded:boolean;
    constructor() {
        makeAutoObservable(this);
        this.filterOptions = {
            submitterId: null,
            status: []
        }
        this.isLoaded =false;
        this.sortOptions =  {
            bySubmitTime: null,
            bySubmitter: null,
            byExecutor: null,
            byStatus: null,
            order: null,
        };
    }
    async initialize(){ 
        this.demandList = await demandApi.getDemandListData();
        this.applyFilters();
        this.applySort();
        this.isLoaded = true;
    }
    
    applyFilters() {
        if(!this.demandList) return;
        this.filteredList = []
        this.filteredList = this.demandList.filter((demand:Demand) => {
            let fullfilled = true;

            if(this.filterOptions.submitterId != null){
                fullfilled = fullfilled && this.filterOptions.submitterId === demand.submitterId; 
            }
            if(this.filterOptions.status != null && this.filterOptions.status.length > 0){
                fullfilled = fullfilled && this.filterOptions.status.includes(demand.status);
            }
            return fullfilled;
        });
    }
    
    applySort() { 
        this.filteredList = this.filteredList.slice().sort((a, b) => {
            let compareResult = 0;
            if (this.sortOptions.bySubmitTime) {
                compareResult = a.submitTime.getTime() - b.submitTime.getTime();
            } else if (this.sortOptions.bySubmitter) {
                compareResult = a.submitterName.localeCompare(b.submitterName);
            } else if (this.sortOptions.byExecutor) {
                compareResult = a.executorName.localeCompare(b.executorName);
            } else if (this.sortOptions.byStatus) {
                compareResult = a.status - b.status;
            }
            return this.sortOptions.order === 'asc' ? compareResult : 0-compareResult;
        });
    }

    collapseAll() {
        // 折叠所有需求项
        (window as any).emitGlobalEvent('bugFolderAll')
    }

    refresh() {
        // 这里可以实现刷新需求列表的逻辑，比如从服务器获取最新数据
    }
}

export const demandPageModel = new DemandPageModel();